import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import TextInput from '../../common/controls/textInput';
import Icon from '../../common/containers/icon';
import useLookup from '../../../utils/useLookup';
const JobPhaseCodeItem = props => {
  const propsOnRemove = props.onRemove,
    propsOnChange = props.onChange,
    index = props.index,
    data = props.data,
    propsDataName = props.data.name;
  const pcLabel = useLookup('Phase Code').toLowerCase();
  const onRemove = () => propsOnRemove(index);
  const handleRemove = () => removeItemWithConfirm(data, pcLabel, ['name'], onRemove);
  const handleChange = (name, value) => propsOnChange(index, {
    name,
    value
  });
  const textProps = {
    data,
    onChange: handleChange,
    entity: 'JobPhaseCode',
    focus: true
  };
  const classContainer = "t-jpc-".concat(kebabCase(propsDataName), " t-jpc-").concat(kebabCase(index));
  return /*#__PURE__*/React.createElement("section", {
    className: classContainer
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    field: "name"
  }, textProps, {
    hideLabel: true,
    placeholder: "Enter ".concat(useLookup('Phase Code'), " Name")
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: handleRemove,
    className: "form-control t-jpc-remove-phase-code tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " ", "Remove ".concat(useLookup('Phase Code'))))));
};
JobPhaseCodeItem.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
export default JobPhaseCodeItem;